<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center">
        <div
          class="col-xl-5 col-lg-5 col-md-6 col-sm-4 col-12 align-items-center"
        >
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div>
              <h1 class="title-view">Quote</h1>

              <div class="box-id">
                <span class="number-id"> {{ quote.quoteNumber }} </span>
                <span class="ml-2 mr-2">|</span>
                <div class="status-tab" v-if="quote.status">
                  <div
                    class="badge-status text-status"
                    v-bind:class="getStatusClass(quote.status)"
                  >
                    {{ formatQuoteStatus(quote.status) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-xl-7 col-lg-7 col-md-6 col-sm-8 col-12 align-items-center alinmov2"
        >
          <div class="box-buttons">
            <div class="d-inline-block mr-1">
              <b-form-group v-slot="{ ariaDescribedbyview }">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="mode"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  button-variant="outline-neutral pc-4"
                >
                  <b-form-radio value="view">
                    <el-tooltip content="Expanded View" placement="bottom"
                      ><i class="flaticon-bold-menu mt-1"></i></el-tooltip
                  ></b-form-radio>
                  <b-form-radio value="list">
                    <el-tooltip content="List View" placement="bottom"
                      ><i class="flaticon-two mt-1"></i></el-tooltip
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <base-dropdown
              v-if="hasAvailableActions"
              menu-on-left
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-menu-1"></i>
                <strong class="d-lg-block d-none">Actions</strong>
              </base-button>

              <div
                class="dropdown-item"
                v-if="canUserChangeStatus && canConvertQuote(quote.status)"
                @click="convertToBooking(quoteId, convertQuoteToBookingById)"
              >
                <span class="icon-action">
                  <i class="flaticon-right-4 text-confirmed"> </i>
                  Convert to Reservation
                </span>
              </div>

              <div
                class="dropdown-item"
                v-if="canDownloadQuotePDF(quote.status)"
                @click="
                  downloadQuotePDF(
                    quoteId,
                    quote.quoteNumber,
                    downloadQuoteById
                  )
                "
              >
                <span class="icon-action">
                  <i class="flaticon-web-bill-2"></i>Download Quote
                </span>
              </div>
              <div
                class="dropdown-item"
                v-if="canUserCreate && canDuplicateQuote(quote.status)"
                @click="duplicateQuote(quoteId, duplicateQuoteById)"
              >
                <span class="icon-action">
                  <i class="flaticon-copy"></i>Duplicate
                </span>
              </div>
              <div class="dropdown-divider"></div>
              <div
                class="dropdown-item"
                v-if="canUserChangeStatus && canCancelQuote(quote.status)"
                @click="cancelQuote(quoteId, cancelQuoteById)"
              >
                <span class="icon-action">
                  <i class="flaticon-remove text-cancelled"></i>
                  Cancel
                </span>
              </div>
            </base-dropdown>

            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
              v-if="mode === 'edit' && canUserUpdate"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-plus"></i>
                <strong class="d-lg-block d-none">Add</strong>
              </base-button>
              <div class="dropdown-item" @click="openExtrasModal()">
                <span class="icon-action"> Add Extras </span>
              </div>

              <div class="dropdown-item" @click="openDiscountModal()">
                <span class="icon-action"> Add Discount </span>
              </div>
            </base-dropdown>

            <base-button
              type="outline-secondary"
              @click="mode = 'edit'"
              class="min-button ml-2 no-mb"
              v-if="(mode === 'view' || mode === 'list') && canUserUpdate"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              @click="storeQuote()"
              class="min-button ml-2 no-mb"
              v-if="mode === 'edit' && canUserUpdate"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="row">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
          v-if="isRequoteNeeded || includesExtraServices"
        >
          <base-alert type="warning" class="mb-2 info-min">
            <i class="flaticon-warning mr-1"></i>

            <strong>Important!</strong>

            <ol class="pl-3 mb-0">
              <li v-if="isRequoteNeeded">
                <span class="span-alert">
                  <strong>Quote Expired:</strong> The quote period for this
                  quote has expired. You can resume the quote once it has been
                  re-quoted.
                  <span class="curp" @click="recalculateExpiredReservation()"
                    ><strong>Click here to re-quoted.</strong></span
                  ></span
                >
              </li>
              <li v-if="includesExtraServices">
                <span class="span-alert" v-if="mode === 'edit'">
                  <strong>You are adding a child seat(s).</strong> You must
                  verify with the supplier that the requested child seat(s) can
                  be fulfilled. Even if child seats have no additional cost,
                  they must be registered as extras in the system with a price
                  of 20 USD/EUR once the supplier has confirmed availability. If
                  any additional costs apply, add the extra to the reservation
                  and contact the customer to process the payment. After adding
                  the extra, send a notification to the customer confirming the
                  update.
                </span>
                <span class="span-alert" v-else>
                  <strong> This reservation includes child seat(s). </strong>
                  Please ensure that the availability has been confirmed with
                  the supplier and that the child seat(s) have been correctly
                  added as extras. Child seats must appear as extras in the
                  charges. If any additional charges apply, the customer should
                  have been contacted and notified accordingly.
                </span>
              </li>
            </ol>
          </base-alert>
        </div>

        <div v-show="mode === 'view'" class="forms ticket">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 box-ticket">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="header-ticket">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov1 align-self-center"
                            >
                              <span class="capitalize title-passenger">
                                {{
                                  buildPassengerTitleByGender(passenger.gender)
                                }}
                                {{ passenger.fullName }}</span
                              >

                              <span class="date-time">
                                {{ formatQuoteDate(quote.pickupDate) }}
                                at
                                {{ formatQuoteTime(quote.pickupTime) }}
                              </span>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 mt-sm-0 mt-3 align-self-center"
                            >
                              <span class="label-total"> TOTAL CHARGES: </span>

                              <span
                                class="price-total"
                                :class="
                                  quote.pricing.totals.gross_price < 0
                                    ? 'loss-alert'
                                    : ''
                                "
                              >
                                {{ currency.symbol }}
                                {{
                                  parsePrice(quote.pricing.totals.gross_price)
                                }}
                                {{ currency.code }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-12">
                        <div class="card-ticket">
                          <div class="box">
                            <div class="row">
                              <div class="col-12 p-0">
                                <div class="col-12 mt-lg-0 mt-md-3 mt-sm-3">
                                  <div class="address-content">
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-start text-primary"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one"
                                        >Pickup:
                                        {{ formatQuoteTime(quote.pickupTime) }}
                                      </span>
                                      <span class="title-two">
                                        {{ quote.origin.name }}
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    class="address-content mt-2"
                                    v-if="quote.type !== 'HOURLY'"
                                  >
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-placeholder-1 text-success"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one">Dropoff </span>
                                      <span class="title-two">
                                        {{ quote.destination.name }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="box box-services">
                            <div class="row" v-if="service !== null">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-serv-v card-select">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <img
                                      v-lazy="service.vehicle.image"
                                      class="img-fluid es-img-service"
                                      alt="Service Car"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-4 col-lg-5 col-md-5 col-sm-9 col-12 align-self-center alinmov4 pl-sm-0 pr-0"
                                  >
                                    <h2 class="title-serv">
                                      {{
                                        formatServiceCategory(
                                          service.vehicle.category
                                        )
                                      }}

                                      {{ service.vehicle.seats }} seats
                                    </h2>

                                    <span class="type-card"
                                      >{{ service.vehicle.make_label }} or
                                      Similar</span
                                    >

                                    <div class="descrip">
                                      <span>
                                        <i class="flaticon-people-1"></i>
                                        PAX: {{ service.vehicle.seats }}
                                      </span>

                                      <span>
                                        <i class="flaticon-briefcase"></i>
                                        Bags: {{ service.vehicle.suitcases }}
                                      </span>
                                    </div>

                                    <div class="more-details">
                                      <ul class="mb-0">
                                        <li v-if="service.preference.wifi">
                                          WiFi onboard
                                        </li>
                                        <li v-if="service.preference.water">
                                          Water
                                        </li>
                                        <li
                                          v-if="
                                            service.preference.hand_sanitizer
                                          "
                                        >
                                          Hand Sanitizer
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    class="col-xl-6 col-lg-5 col-md-5 col-sm-12 col-12 alinmov8 align-self-center pl-lg-0"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 supplier-box"
                          >
                            <div class="item-content-2">
                              <label>Destination: </label
                              ><span class="ml-1">
                                {{ getBranchName(quote.branch) }}
                              </span>
                              <span class="mx-2 no-mobile-xxs">|</span>
                            </div>

                            <div class="item-content-2">
                              <label>Supplier: </label
                              ><span class="ml-1">
                                <a
                                  :href="`/suppliers/${quote.supplier}`"
                                  target="_blank"
                                >
                                  {{ getSupplierName(quote.supplier) }}
                                </a>
                                <el-popover
                                  placement="bottom"
                                  trigger="hover"
                                  width="300"
                                  class="curp d-inline-flex ml-1"
                                  v-if="getSupplierNotes(quote.supplier)"
                                >
                                  <span>
                                    <strong>Notes: </strong>
                                    <span class="text-min">
                                      {{ getSupplierNotes(quote.supplier) }}
                                    </span>
                                  </span>

                                  <div
                                    slot="reference"
                                    class="badge badge-note"
                                  >
                                    Note
                                  </div>
                                </el-popover>
                              </span>
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Type Transfer</span>
                                  <span class="content-block">
                                    {{ formatTransferType(quote.type) }}
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX N°</span>
                                  <span class="content-block"
                                    >{{ quote.passengersCount }} PAX</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX</span>
                                  <span class="content-block">
                                    {{
                                      buildPassengerTitleByGender(
                                        passenger.gender
                                      )
                                    }}
                                    {{ passenger.fullName }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block"
                                    >Contact Number</span
                                  >
                                  <span class="content-block"
                                    >{{ passenger.phone }}
                                    <el-tooltip
                                      content="Copy"
                                      placement="bottom"
                                    >
                                      <span
                                        class="curp ml-2"
                                        v-clipboard:copy="passenger.phone"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onErrorCopy"
                                      >
                                        <i
                                          class="flaticon-copy link ml-0"
                                        ></i></span></el-tooltip
                                  ></span>
                                </div>
                              </div>

                              <div
                                :class="{
                                  'col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12':
                                    quote.routerReference,
                                  'col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12': !quote.routerReference
                                }"
                              >
                                <div class="data-block">
                                  <span class="title-block">Customer</span>
                                  <span class="content-block">
                                    <a
                                      class="capitalize"
                                      :href="
                                        [
                                          'travel_agency',
                                          'travel_access'
                                        ].includes(customer.type)
                                          ? `/partners/profile/${customer._id}`
                                          : `/edit-costumer/${customer._id}`
                                      "
                                      target="_blank"
                                      >{{ customer.first_name }}
                                      {{ customer.last_name }}
                                    </a>
                                    <span class="type-card">
                                      -
                                      {{
                                        formatCustomerType(customer.type)
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="quote.type !== 'JOURNEY'"
                              >
                                <div class="data-block">
                                  <span class="title-block">
                                    {{ getTransferTypeLabel(quote.type) }}
                                  </span>
                                  <span
                                    class="content-block uppercase"
                                    v-if="
                                      ['ARRIVAL', 'DEPARTURE'].includes(
                                        quote.type
                                      )
                                    "
                                  >
                                    <span
                                      class="uppercase link ml-0"
                                      v-if="quote.routerReference"
                                      @click="
                                        getFlightsInformationByIdent(
                                          quote.routerReference
                                        )
                                      "
                                    >
                                      {{ quote.routerReference }}
                                      <i class="flaticon-link"></i>
                                    </span>
                                    <span v-else class="uppercase"
                                      >Not included</span
                                    >
                                  </span>

                                  <div
                                    v-if="quote.type === 'PORT'"
                                    class="content-block"
                                  >
                                    <span
                                      class="uppercase"
                                      v-if="quote.routerReference"
                                      >{{ quote.routerReference }}</span
                                    >

                                    <span v-else class="uppercase"
                                      >Not included</span
                                    >
                                  </div>

                                  <div
                                    class="content-block"
                                    v-if="quote.type === 'STATION'"
                                  >
                                    <span
                                      class="uppercase"
                                      v-if="quote.routerReference"
                                      >{{ quote.routerReference }}</span
                                    >

                                    <span v-else class="uppercase"
                                      >Not included</span
                                    >
                                  </div>

                                  <span
                                    class="content-block uppercase"
                                    v-if="quote.type === 'HOURLY'"
                                    >{{ quote.routerReference }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                v-if="quote.routerReference && flight"
                              >
                                <FlightDetails mode="view" :flight="flight" />
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Pickup Sign</span>
                                  <div v-if="pdfDataUrl" class="content-block">
                                    <span
                                      class="link ml-0"
                                      @click="openPreviewPickup()"
                                    >
                                      <i class="flaticon-visualization mr-1"></i
                                      >File uploaded</span
                                    >
                                  </div>

                                  <div v-else>
                                    <span
                                      class="content-block"
                                      v-if="quote.pickupSign.text"
                                      >{{ quote.pickupSign.text }}</span
                                    >

                                    <span class="content-block" v-else
                                      >NONE</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2" v-if="includesExtraServices">
                        <div class="card pb-2 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Extras</span>
                          </div>

                          <div class="row">
                            <div
                              class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="quote.specialRequirements"
                            >
                              <div class="data-block">
                                <span class="title-block"
                                  >Special Requirements</span
                                >
                                <span class="content-block">
                                  {{ quote.specialRequirements }}
                                </span>
                              </div>
                            </div>

                            <div
                              class="col-xl-4 col-lg-8 col-md-8 col-sm-12 col-12"
                              v-if="quote.childSeatsCount > 0"
                            >
                              <div class="data-block">
                                <span class="title-block">Child Seats N°</span>
                                <span class="content-block"
                                  >{{ quote.childSeatsCount }} Seats</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-12 col-12 mt-2"
                        v-if="quote.passengers.length > 1"
                      >
                        <div class="card mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">PAX</span>
                          </div>
                          <div>
                            <b-table
                              hover
                              :items="quote.passengers"
                              :fields="
                                formatPassengerTableHeaders(
                                  fieldsPassengerView,
                                  quote.type
                                )
                              "
                              sort-by.sync="fullname"
                              sort-desc.sync="true"
                              select-mode="single"
                              ref="tableviewpassengers"
                              sort-icon-left
                              responsive
                              show-empty
                              empty-filtered-text="There are no records matching your request"
                              empty-text="There are no records to show"
                            >
                              <template #cell(fullname)="data">
                                <span class="text-capitalize"
                                  >{{
                                    buildPassengerTitleByGender(
                                      data.item.gender
                                    )
                                  }}
                                  {{ data.item.firstName }}
                                  {{ data.item.lastName }}
                                </span>

                                <span
                                  class="badge-status badge-default mr-2"
                                  v-if="data.item.primary"
                                  >Primary</span
                                >
                              </template>

                              <template #cell(phone)="data">
                                <span v-if="data.item.phone">{{
                                  data.item.phone
                                }}</span>
                                <span v-else>N/A</span>
                              </template>

                              <template #cell(email)="data">
                                <span v-if="data.item.email">
                                  {{ data.item.email }}
                                </span>
                                <span v-else> N/A</span>
                              </template>

                              <template #cell(itinerary)="data">
                                <span
                                  class="uppercase"
                                  v-if="data.item.flightNumber"
                                  >{{ data.item.flightNumber }}</span
                                >
                                <span v-else>N/A</span>
                              </template>

                              <template #cell(type)="data">
                                {{ formatPassengerType(data.item.type) }}
                              </template>
                              <template #cell(notify)="data">
                                {{ data.item.notify ? "Yes" : "No" }}
                              </template>
                            </b-table>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.keyDetails"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14">Key Details</span>
                            <span class="content-block">
                              {{ service.keyDetails }}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2" v-if="service">
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Cancellations Policies</span
                            >
                          </div>

                          <ul class="cancellations-list">
                            <li
                              v-for="(item,
                              index) in service.cancellationPolicy"
                              :key="`${index}`"
                            >
                              {{ item }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-2"
                        v-if="service && service.termsConditions"
                      >
                        <div class="card pb-3 mb-0">
                          <div class="data-block mb-2">
                            <span class="title-block f-14"
                              >Terms and Conditions</span
                            >
                            <span class="content-block">
                              {{ service.termsConditions }}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-12 mt-2">
                        <div class="card box-created">
                          <span>
                            <strong>Created: </strong>
                            {{ formatQuoteDate(createdAt) }} at
                            {{ formatQuoteTime(createdAt) }}
                            | By
                            <strong>
                              {{
                                responsible ? responsible.fullName : "Unknown"
                              }}
                            </strong>
                            -
                            {{ responsible ? responsible.position : "Unknown" }}
                          </span>
                          <span
                            ><strong>Origin:</strong>
                            {{ getSourceOrigin(quote.source) }} |
                            <strong> Service Provider:</strong>
                            {{ formatSourceProvider(quote.source) }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'transfer'"
                  :currency="currency"
                  :pricing="quote.pricing"
                  :operation="'edit'"
                  :mode="'view'"
                  :markUp="customer.mark_up"
                  :markUpType="customer.type_markup"
                  :status="quote.status"
                  :adjustmentsAvailable="
                    getAdjustmentsStatus(quote.service, quote.customer)
                  "
                  :commissions="quote.commissions"
                  :surcharges="quote.surcharges"
                  @addAdjustments="addAdjustments"
                />

                <div class="row">
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                    v-if="quote.dealNumber"
                  >
                    <div class="card card py-3">
                      <h2 class="subtitle mb-1">External References</h2>
                      <div class="item-selected" v-if="quote.dealNumber">
                        <span>
                          <strong>Zoho Deal Number: </strong>
                          {{ quote.dealNumber }}
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="quote.dealNumber"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i>
                            </span> </el-tooltip
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" v-show="mode === 'list'">
          <div class="card">
            <!-- {{ reservation }} -->
            <div class="review">
              <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Address / Date & Time</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Reservation ID:</label
                    >
                    <span>{{ quote.quoteNumber }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">
                      Reservation Type:
                    </label>
                    <span>Private Transfer</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Type Transfer:</label
                    >
                    <span>{{ formatTransferType(quote.type) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Pick Up Date:</label>
                    <span> {{ formatQuoteDate(quote.pickupDate) }}</span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Pick Up Time:</label>
                    <span> {{ formatQuoteTime(quote.pickupTime) }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">From:</label>
                    <span>{{ quote.origin.name }}</span>
                  </div>

                  <div v-if="quote.type !== 'HOURLY'">
                    <label class="form-control-label pr-1">To:</label>
                    <span>{{ quote.destination.name }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX N°:</label>
                    <span>{{ quote.passengersCount }} PAX</span>
                  </div>

                  <div>
                    <div v-if="quote.type !== 'HOURLY'">
                      <label class="form-control-label pr-1">
                        {{ getTransferTypeLabel(quote.type) }}
                      </label>
                      <span v-if="['ARRIVAL', 'DEPARTURE'].includes(quote.type)"
                        ><span
                          class="uppercase link ml-0"
                          v-if="quote.routerReference"
                          @click="
                            getFlightsInformationByIdent(quote.routerReference)
                          "
                          >{{ quote.routerReference }}
                          <i class="flaticon-link"></i>
                        </span>
                        <span v-else class="uppercase">Not included</span></span
                      >
                      <span v-if="quote.type === 'STATION'">
                        <span class="uppercase" v-if="quote.routerReference">{{
                          quote.routerReference
                        }}</span>

                        <span v-else class="uppercase">Not included</span></span
                      >
                      <span v-if="quote.type === 'STATION'">
                        <span class="uppercase" v-if="quote.routerReference">{{
                          quote.routerReference
                        }}</span>

                        <span v-else class="uppercase">Not included</span></span
                      >
                    </div>
                    <div v-else>
                      <label class="form-control-label pr-1">
                        {{ getTransferTypeLabel(quote.type) }}
                      </label>
                      <span>{{ quote.routerReference }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">Service / Supplier</h4>

                  <div>
                    <label class="form-control-label pr-1">Supplier:</label>
                    <span v-if="supplier !== null">
                      {{ getSupplierName(quote.branch) }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Destination:</label>
                    <span v-if="branch !== null">
                      {{ getBranchName(quote.branch) }}</span
                    >
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Service Type:</label>
                    <span v-if="service !== null">
                      {{ formatServiceCategory(service.vehicle.category) }}
                      {{ service.vehicle.seats }} seats
                    </span>
                  </div>
                  <div v-if="service !== null">
                    <label class="form-control-label pr-1">Vehicle:</label>
                    <span v-if="service !== null">
                      {{ service.vehicle.make_label }} or Similar
                    </span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <h4 class="subtitle mb-2">PAX / Customer</h4>

                  <div>
                    <label class="form-control-label pr-1">Customer:</label>

                    <span class="capitalize"
                      >{{ customer.first_name }} {{ customer.last_name }} -
                      {{ formatCustomerType(customer.type) }}</span
                    >
                  </div>

                  <div>
                    <label class="form-control-label pr-1">PAX:</label>
                    <span class="capitalize">
                      {{ buildPassengerTitleByGender(passenger.gender) }}
                      {{ passenger.fullName }}
                    </span>
                  </div>
                  <div>
                    <label class="form-control-label pr-1">Email:</label>
                    <span>{{ passenger.email }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1"
                      >Contact Number:</label
                    >
                    <span>{{ passenger.phone }}</span>
                  </div>

                  <div>
                    <label class="form-control-label pr-1">Pickup Sign:</label>

                    <span
                      v-if="pdfDataUrl"
                      class="link ml-0"
                      @click="openPreviewPickup()"
                      ><i class="flaticon-visualization mr-1"></i>File
                      uploaded</span
                    >

                    <span class="break-word" v-else>{{
                      quote.pickupSign.text
                    }}</span>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                  <div v-if="includesExtraServices" class="mb-4">
                    <h4 class="subtitle mb-2">Extras</h4>

                    <div v-if="quote.specialRequirements">
                      <label class="form-control-label pr-1"
                        >Special Requirements:</label
                      >
                      <span class="break-word">
                        {{ quote.specialRequirements }}
                      </span>
                    </div>

                    <div v-if="quote.childSeatsCount > 0">
                      <label class="form-control-label pr-1"
                        >Child Seats N°:</label
                      >
                      <span class="break-word">
                        {{ quote.childSeatsCount }} Seats
                      </span>
                    </div>
                  </div>

                  <h4 class="subtitle mb-2">Pricing / Payment</h4>
                  <div>
                    <label class="form-control-label pr-1"
                      >Total Charges:</label
                    >
                    <span>
                      {{ currency.symbol }}
                      {{ parsePrice(quote.pricing.totals.gross_price) }}
                      {{ currency.code }}
                    </span>
                  </div>

                  <div v-if="quote.dealNumber">
                    <label class="form-control-label pr-1"
                      >Zoho Deal Number:</label
                    >
                    <span> {{ quote.dealNumber }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card pb-3 mb-2" v-if="service && service.keyDetails">
            <div class="data-block mb-2">
              <span class="title-block f-14">Key Details</span>
              <span class="content-block"> {{ service.keyDetails }}</span>
            </div>
          </div>

          <div class="card pb-3 mb-2" v-if="service">
            <div class="data-block mb-2">
              <span class="title-block f-14">Cancellations Policies</span>
            </div>

            <ul class="cancellations-list">
              <li
                v-for="(item, index) in service.cancellationPolicy"
                :key="`${index}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <div class="card pb-3 mb-0" v-if="service && service.termsConditions">
            <div class="data-block mb-2">
              <span class="title-block f-14">Terms and Conditions</span>
              <span class="content-block"> {{ service.termsConditions }}</span>
            </div>
          </div>
        </div>

        <div v-show="mode === 'edit'" class="forms">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card pb-4">
                      <h2 class="subtitle">Type Transfer</h2>

                      <div
                        class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                      >
                        <b-form-radio-group
                          id="btn-radios-1"
                          v-model="quote.type"
                          :options="TRANSFER_OPTIONS"
                          name="radios-btn-default"
                          buttons
                          value-field="value"
                          text-field="label"
                          button-variant="group-neutral"
                          tabindex="1"
                          class="buttons-type"
                          @change="changeTransferType"
                        ></b-form-radio-group>
                      </div>

                      <div
                        class="d-xl-none d-lg-none d-md-none d-sm-none d-block"
                      >
                        <WSelect
                          placeholder="Reservation Type"
                          v-model="quote.type"
                          filterable
                          id="reservationType"
                        >
                          <el-option
                            v-for="option in TRANSFER_OPTIONS"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>

                  <!-- address/date/time/ -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Address / Date & Time</h2>

                      <div class="row">
                        <div class="col-12">
                          <WSelect
                            label="From"
                            v-bind:class="{
                              'is-invalid': $v.quote.origin.name.$error
                            }"
                            id="from"
                            name="from"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationFrom"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.quote.origin.name.$model"
                            @change="selectFrom"
                            indexTab="2"
                            ref="from"
                            :focusact="true"
                            no-data-text="Search by destination or landmark"
                            clearable
                            markrequired
                            allText
                            :error="fromValidationMessage($v.quote.origin.name)"
                          >
                            <el-option
                              v-for="(location, index) in optionsFrom"
                              class
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getLocationIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-12" v-show="quote.type !== 'HOURLY'">
                          <WSelect
                            label="To"
                            v-bind:class="{
                              'is-invalid': $v.quote.destination.name.$error
                            }"
                            id="to"
                            name="to"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationTo"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.quote.destination.name.$model"
                            @change="selectTo"
                            indexTab="3"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            markrequired
                            :error="
                              toValidationMessage($v.quote.destination.name)
                            "
                          >
                            <el-option
                              v-for="(location, index) in optionsTo"
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getLocationIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Date"
                            :error="
                              $v.quote.pickupDate.$error
                                ? `Select Pickup Date`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'd-M-Y',
                                altInput: true,
                                dateFormat: 'Y-m-d',
                                allowInput: true
                              }"
                              class="input-custom"
                              v-model="quote.pickupDate"
                              @input="getRatesWithThePickupDate"
                              id="date"
                              name="date"
                              placeholder="Pickup Date"
                              tabindex="4"
                              markrequired
                            ></flat-picker>
                          </base-input>
                        </div>

                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Time"
                            :error="
                              $v.quote.pickupTime.$error
                                ? `Select Pickup Time`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: 'G:i K',
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: 'G:i K',
                                time_24hr: false,
                                wrap: true
                              }"
                              class="input-custom"
                              v-model="quote.pickupTime"
                              @input="getRatesWithThePickupTime"
                              id="time"
                              name="time"
                              placeholder="Pickup Time"
                              tabindex="5"
                            ></flat-picker>
                          </base-input>
                        </div>

                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                          <base-input
                            class
                            v-auto-zero
                            v-model.number="$v.quote.passengersCount.$model"
                            label="PAX N°"
                            placeholder="PAX N°"
                            id="passengers"
                            name="passengers"
                            type="number"
                            min="1"
                            indexTab="6"
                            markrequired
                            :error="
                              passengersCountValidationMessage(
                                $v.quote.passengersCount
                              )
                            "
                            @input="getRatesWithTheNumberPassengers"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                          v-if="['ARRIVAL', 'DEPARTURE'].includes(quote.type)"
                        >
                          <FlightNumberInput
                            v-model="$v.quote.routerReference.$model"
                            :pickupDate="quote.pickupDate"
                            :pickupTime="quote.pickupTime"
                            :flightType="quote.type"
                            :validation="$v.quote.routerReference"
                            :airport="airport"
                            :airportName="
                              getAirportName(
                                quote.type,
                                quote.origin.name,
                                quote.destination.name
                              )
                            "
                            @input="onFlightNumberInput"
                            @validation-state="handleValidationState"
                            @selectFlight="handleFlightSelection"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="quote.type === 'STATION'"
                        >
                          <base-input
                            v-model.trim="$v.quote.routerReference.$model"
                            label="Rail Line"
                            id="rail_line"
                            name="rail_line"
                            placeholder="Rail Line"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.quote.routerReference.$error
                                ? 'Enter a Valid Rail Line'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="quote.type === 'PORT'"
                        >
                          <base-input
                            v-model.trim="$v.quote.routerReference.$model"
                            label="Cruise Ship"
                            id="routerReference"
                            name="routerReference"
                            placeholder="Cruise Ship"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.quote.routerReference.$error
                                ? 'Enter a Valid Cruise Ship'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="quote.type === 'HOURLY'"
                        >
                          <WSelect
                            class
                            v-bind:class="{
                              'is-invalid': $v.quote.routerReference.$error
                            }"
                            placeholder="Select Hourly"
                            v-model.trim="$v.quote.routerReference.$model"
                            @input="getRatesWithTheHourly"
                            id="number_hourly"
                            name="number_hourly"
                            indexTab="8"
                            label="Hourly"
                            @change="changeRouterReference"
                            :error="
                              $v.quote.routerReference.$error
                                ? 'Select an Hours'
                                : ''
                            "
                          >
                            <el-option
                              v-for="number in minimumSelect"
                              :value="number"
                              :label="number"
                              :key="number"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-if="quote.routerReference && flight"
                        >
                          <FlightDetails mode="edit" :flight="flight" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- service/Supplier -->
                  <div class="col-xl-12" v-if="showRates">
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.quote.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                        >
                          <h2 class="subtitle">Service / Supplier</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            class="service-filters"
                            v-if="serviceAux.length > 0"
                          >
                            <div class="col-filter no-mov justify-content-end">
                              <WSelect
                                placeholder="Supplier"
                                v-model="supplierFilter"
                                id="supplierFilter"
                                name="supplierFilter"
                                filterable
                                :loading="loading"
                                indexTab="10"
                                @change="changeSupplier"
                                label="Supplier"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="supplier in suppliersOptions"
                                  :value="supplier._id"
                                  :label="supplier.businessDetails.name"
                                  :key="supplier._id"
                                ></el-option>
                              </WSelect>
                            </div>
                            <div class="col-filter no-mov justify-content-end">
                              <WSelect
                                placeholder="Destination"
                                v-model="branchFilter"
                                id="branchFilter"
                                name="branchFilter"
                                filterable
                                indexTab="11"
                                @change="changeBranch"
                                label="Destination"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="branch in branches"
                                  :value="branch._id"
                                  :label="branch.name"
                                  :key="branch._id"
                                ></el-option>
                              </WSelect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-xl-12">
                          <base-alert
                            v-if="loaderService == 'NOT_FOUND'"
                            type="danger"
                            class="mb-0 info-min"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Not Found!</strong> There are no services
                            available for your search. Check the from and to.
                          </base-alert>

                          <div class="container-services">
                            <div class="content-service">
                              <div v-if="loaderService === 'RESULTS'">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                  v-for="(element, index) in serviceAux"
                                  :key="index"
                                >
                                  <Services
                                    :suppliers="suppliersOptions"
                                    :branches="branchesOptions"
                                    :selected="
                                      getSelectServices(service, element)
                                    "
                                    :service="element"
                                    @selectService="processServiceSelection"
                                    :transferType="quote.type"
                                    :hourly="
                                      quote.type === 'HOURLY' &&
                                      isNumber(quote.routerReference)
                                        ? quote.routerReference
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="loaderService === 'SEARCHING'">
                            <div class="text-center pt-0 pb-4">
                              <h4><strong>Finding services...</strong></h4>
                              <span class="loader-pin"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12" v-else>
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.quote.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-7 align-self-center"
                        >
                          <h2 class="subtitle">Service / Supplier</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-5 text-right form-group-no-margin align-self-center"
                        >
                          <div class="service-filters">
                            <div class="col-filter">
                              <base-button
                                class="min-button"
                                type="outline-neutral"
                                @click="requote()"
                              >
                                <i class="flaticon-pencil mr-2"></i>
                                Edit
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="col-xl-12">
                            <div class="row">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                v-if="service !== null"
                              >
                                <Services
                                  :styleCard="'single'"
                                  :suppliers="suppliersOptions"
                                  :branches="branchesOptions"
                                  :selected="false"
                                  :service="service"
                                  :transferType="quote.type"
                                  :hourly="
                                    quote.type === 'HOURLY' &&
                                    isNumber(quote.routerReference)
                                      ? quote.routerReference
                                      : 0
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- customer -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Customer</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            label="Customer"
                            v-bind:class="{
                              'is-invalid': $v.quote.customer.$error
                            }"
                            class
                            filterable
                            remote
                            :remote-method="getCustomer"
                            :loading="loading"
                            placeholder="Enter Name Customer"
                            v-model="customerId"
                            id="customer"
                            name="customer"
                            indexTab="13"
                            @input="selectCustomer"
                            no-data-text="Search by Customer"
                            clearable
                            markrequired
                          >
                            <el-option
                              v-for="(customer, index) in customers"
                              :value="customer._id"
                              :label="getCustomerLabel(customer)"
                              :key="index"
                            >
                              <div class="row">
                                <div class="col-7 align-self-center">
                                  <span
                                    class="role-table"
                                    v-if="
                                      [
                                        'travel_agency',
                                        'travel_access'
                                      ].includes(customer.type)
                                    "
                                    >{{ customer.company_name }}</span
                                  >
                                  <span>
                                    {{ customer.first_name }}
                                    {{ customer.last_name }}
                                  </span>
                                </div>
                                <div
                                  class="col-5 text-right hide-data align-self-center"
                                >
                                  <span class="coin-right">
                                    {{ formatCustomerType(customer.type) }}
                                  </span>
                                </div>
                              </div>
                            </el-option>
                          </WSelect>
                          <small
                            class="invalid-feedback"
                            v-if="$v.quote.customer.$error"
                            >Enter a Customer</small
                          >

                          <div v-if="copyData" class="text-right">
                            <base-button
                              class="linkfill"
                              @click="copyDataCustomer"
                              tabindex="14"
                              >+ Fill Customer Data</base-button
                            >
                          </div>
                        </div>
                        <AddCustomer
                          :show="modalCustomer"
                          @closeNewCustomerModal="closeNewCustomerModal"
                          @customer="addCustomerInOptions"
                        />

                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="modalCustomer = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- passengers -->
                  <div class="col-xl-12">
                    <div class="card">
                      <div class="row mb-2">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-8 align-self-center"
                        >
                          <h2 class="subtitle mb-0">PAX</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-4 text-right form-group-no-margin align-self-center"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button mb-0"
                            @click="importPassengers"
                          >
                            <i class="flaticon-up-2"></i> Import
                            <input
                              type="file"
                              ref="fileInput"
                              accept=".csv"
                              class="d-none"
                              @change="bulkPassengers"
                            />
                          </base-button>
                          <base-button
                            class="min-button mb-0"
                            type="outline-neutral"
                            @click="addNewPassenger"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>

                      <NewPassenger
                        :show="showNewPassengerModal"
                        :partner="{
                          id: customer ? customer._id : null,
                          type: customer ? customer.type : ''
                        }"
                        :passengers="passengers"
                        :passengersIncluded="quote.passengers"
                        :maxPassengers="quote.passengersCount"
                        :transferType="quote.type"
                        @addPassenger="addPassenger"
                        @close="closeNewPassengerModal"
                      />
                      <EditPassenger
                        :show="showEditPassengerModal"
                        :partner="{
                          id: customer ? customer._id : null,
                          type: customer ? customer.type : ''
                        }"
                        :transferType="quote.type"
                        :tempPassenger="tempPassenger"
                        @changePassenger="upadtePassenger"
                        @close="closeEditPassengerModal"
                      />

                      <div class="mb-4" v-if="quote.passengers.length === 0">
                        <base-alert type="warning" class="mb-1 info-min">
                          <i class="flaticon-warning mr-1"></i> There are no PAX
                          here
                        </base-alert>
                      </div>
                      <div
                        class="list-card"
                        v-if="quote.passengers.length === 1"
                      >
                        <div
                          class="card card-min"
                          v-for="(element, index) in quote.passengers"
                        >
                          <div class="row">
                            <div
                              class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 align-self-center"
                            >
                              <div class="row">
                                <div
                                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-self-center"
                                >
                                  <div class="data-block">
                                    <div>
                                      <span class="content-block"
                                        ><strong>Full Name:</strong>
                                        {{
                                          buildPassengerTitleByGender(
                                            element.gender
                                          )
                                        }}
                                        {{ element.firstName }}
                                        {{ element.lastName }}
                                      </span>

                                      <span
                                        v-if="element.phone"
                                        class="content-block"
                                        ><strong>Contact Number:</strong>
                                        {{ element.phone }}
                                        <el-tooltip
                                          content="Copy"
                                          placement="bottom"
                                        >
                                          <span
                                            class="curp ml-2"
                                            v-clipboard:copy="element.phone"
                                            v-clipboard:success="onCopy"
                                            v-clipboard:error="onErrorCopy"
                                          >
                                            <i
                                              class="flaticon-copy link ml-0"
                                            ></i></span
                                        ></el-tooltip>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 align-self-center"
                                >
                                  <div class="data-block">
                                    <span
                                      v-if="element.email"
                                      class="content-block"
                                      ><strong>Email:</strong>
                                      {{ element.email }}
                                      <el-tooltip
                                        content="Copy"
                                        placement="bottom"
                                      >
                                        <span
                                          class="curp ml-2"
                                          v-clipboard:copy="element.email"
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onErrorCopy"
                                        >
                                          <i
                                            class="flaticon-copy link ml-0"
                                          ></i></span
                                      ></el-tooltip>
                                    </span>
                                    <span class="content-block"
                                      ><strong>Segment:</strong>
                                      {{ formatPassengerType(element.type) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 align-self-center alinmov6"
                            >
                              <el-tooltip
                                content="Edit"
                                placement="bottom"
                                class="d-inline-flex"
                              >
                                <span
                                  class="icon-action mr-2"
                                  @click.stop="
                                    openEditPassengerModal(element, index)
                                  "
                                >
                                  <i class="flaticon-pencil text-primary"></i>
                                </span>
                              </el-tooltip>

                              <el-tooltip
                                content="Copy data"
                                placement="bottom"
                              >
                                <span
                                  class="icon-action mr-2"
                                  @click.stop="copyPassengerData(element)"
                                >
                                  <i class="flaticon-copy text-black"></i>
                                </span>
                              </el-tooltip>
                              <el-tooltip
                                content="Remove"
                                placement="bottom"
                                class="d-inline-flex"
                              >
                                <span
                                  class="icon-action"
                                  @click.stop="
                                    removePassenger(index, element.primary)
                                  "
                                >
                                  <i class="flaticon-cancel text-danger"></i>
                                </span>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="w-100">
                        <b-table
                          hover
                          :items="quote.passengers"
                          :fields="
                            formatPassengerTableHeaders(
                              fieldsPassenger,
                              quote.type
                            )
                          "
                          sort-by.sync="fullname"
                          sort-desc.sync="true"
                          selectable
                          @row-selected="onRowSelected"
                          select-mode="multi"
                          ref="selectableTable"
                          sort-icon-left
                          responsive
                          show-empty
                          empty-filtered-text="There are no records matching your request"
                          empty-text="There are no records to show"
                        >
                          <template #cell(fullname)="data">
                            <span class="text-capitalize"
                              >{{
                                buildPassengerTitleByGender(data.item.gender)
                              }}
                              {{ data.item.firstName }}
                              {{ data.item.lastName }}
                            </span>

                            <span
                              class="badge-status badge-default mr-2"
                              v-if="data.item.primary"
                              >Primary</span
                            >
                          </template>

                          <template #cell(phone)="data">
                            <span v-if="data.item.phone">{{
                              data.item.phone
                            }}</span>
                            <span v-else>N/A</span>
                          </template>

                          <template #cell(email)="data">
                            <span
                              class="hide-data lower"
                              v-if="data.item.email"
                            >
                              {{ data.item.email }}
                            </span>
                            <span v-else> N/A</span>
                          </template>

                          <template #cell(itinerary)="data">
                            <span
                              class="uppercase"
                              v-if="data.item.flightNumber"
                              >{{ data.item.flightNumber }}</span
                            >
                            <span v-else>N/A</span>
                          </template>

                          <template #cell(type)="data">
                            {{ formatPassengerType(data.item.type) }}
                          </template>
                          <template #cell(notify)="data">
                            {{ data.item.notify ? "Yes" : "No" }}
                          </template>
                          <template #cell(actions)="data">
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action mr-2"
                                @click.stop="
                                  openEditPassengerModal(data.item, data.index)
                                "
                              >
                                <i class="flaticon-pencil text-primary"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Mark as primary"
                              placement="bottom"
                              v-if="!data.item.primary"
                            >
                              <span
                                class="icon-action mr-2"
                                @click.stop="makePassengerAsDefault(data.index)"
                              >
                                <i class="flaticon-bold-button text-new"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Copy data" placement="bottom">
                              <span
                                class="icon-action mr-2"
                                @click.stop="copyPassengerData(data.item)"
                              >
                                <i class="flaticon-copy text-black"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Remove" placement="bottom">
                              <span
                                class="icon-action"
                                @click.stop="
                                  removePassenger(data.index, data.item.primary)
                                "
                              >
                                <i class="flaticon-cancel text-danger"></i>
                              </span>
                            </el-tooltip>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle">Pickup Sign</h2>

                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 align-self-center"
                        >
                          <div v-if="pdfDataUrl">
                            <div class="pdfPreview mb-4">
                              <iframe
                                :src="pdfDataUrl"
                                width="235px"
                                height="160px"
                                frameborder="0"
                                allowfullscreen
                                class="pdf-iframe"
                                scrolling="no"
                              ></iframe>

                              <el-tooltip
                                content="Open / Expand"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-expand"
                                  @click="openPreviewPickup()"
                                >
                                  <i class="flaticon-expand"></i></div
                              ></el-tooltip>

                              <el-tooltip
                                content="Remove Pickup Sign"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-remove"
                                  @click="clearfile()"
                                >
                                  <i class="flaticon-delete"></i></div
                              ></el-tooltip>
                            </div>
                          </div>

                          <el-input
                            v-else
                            v-model="quote.pickupSign.text"
                            placeholder="Pickup Sign"
                            id="pickupSign"
                            name="pickupSign"
                            maxlength="200"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 5 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                          v-if="!pdfDataUrl"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button"
                            @click="uploadPickupSign"
                          >
                            <i class="flaticon-up-2"></i> Upload Pickup Sign
                            <input
                              type="file"
                              ref="pickupSign"
                              accept=".pdf"
                              model="pickupSign"
                              @change="readPickupSign"
                              class="d-none"
                            />
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-3">Extras</h2>

                      <div class="row">
                        <div
                          class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 mb-3"
                        >
                          <label class="title-label" for="specialrequirements"
                            >Special Requirements</label
                          >
                          <el-input
                            v-model="quote.specialRequirements"
                            placeholder="Special Requirements"
                            id="Special Requirements"
                            name="Special Requirements"
                            maxlength="500"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 10 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            v-auto-zero
                            v-model.number="quote.childSeatsCount"
                            label="Child Seats N°"
                            id="child_seat"
                            name="child_seat"
                            placeholder="Child Seat"
                            type="number"
                            min="0"
                            indexTab="7"
                          />
                        </div>

                        <div
                          class="col-12 mt-0 mb-4"
                          v-if="includesExtraServices"
                        >
                          <base-alert type="warning" class="mb-0 info-min">
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Important!</strong>
                            <span class="span-alert">
                              <strong>You are adding a child seat(s)</strong>
                              You must verify with the supplier that the
                              requested child seat(s) can be fulfilled. Even if
                              child seats have no additional cost, they must be
                              registered as extras in the system with a price of
                              20 USD/EUR once the supplier has confirmed
                              availability. If any additional costs apply, add
                              the extra to the reservation and contact the
                              customer to process the payment. After adding the
                              extra, send a notification to the customer
                              confirming the update.
                            </span>
                          </base-alert>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-12">
                    <div class="card box-created">
                      <span>
                        <strong>Created: </strong>
                        {{ formatQuoteDate(createdAt) }} at
                        {{ formatQuoteTime(createdAt) }}
                        | By
                        <strong>
                          {{ responsible ? responsible.fullName : "Unknown" }}
                        </strong>
                        -{{ responsible ? responsible.position : "Unknown" }}
                      </span>
                      <span
                        ><strong>Channel:</strong>
                        Mobility Internal |
                        <strong> Service Provider:</strong> RhomTrip</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'transfer'"
                  :currency="currency"
                  :pricing="quote.pricing"
                  :operation="'edit'"
                  :mode="'edit'"
                  :markUp="customer.mark_up"
                  :markUpType="customer.type_markup"
                  :status="quote.status"
                  :adjustmentsAvailable="
                    getAdjustmentsStatus(quote.service, quote.customer)
                  "
                  :commissions="quote.commissions"
                  :surcharges="quote.surcharges"
                  @addAdjustments="addAdjustments"
                />

                <div class="row">
                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">External References</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-7 col-sm-7 col-12"
                        >
                          <base-input
                            placeholder="Zoho Deal Number"
                            v-model.trim="$v.quote.dealNumber.$model"
                            id="deal_number"
                            name="deal_number"
                            label="Zoho Deal Number"
                            type="text"
                            :error="
                              dealNumberValidationMessage($v.quote.dealNumber)
                            "
                          ></base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ManageExtraCharges
      :show="showExtrasModal"
      :markUp="customer.mark_up"
      :markUpType="customer.type_markup"
      :extras="quote.pricing.extras"
      :currency="currency"
      @change="manageExtras"
      @close="closeExtrasModal"
    />
    <ManageDiscounts
      :show="showDiscountModal"
      :grossPrice="quote.pricing.totals.gross_price"
      :discounts="quote.pricing.discounts"
      :currency="currency"
      @change="manageDiscounts"
      @close="closeDiscountModal"
    />
    <ManagePriceAdjustments
      :show="showPriceAdjusments"
      :markUp="customer.mark_up"
      :markUpType="customer.type_markup"
      :pricing="quote.pricing"
      :lastGrossPrice="lastGrossPrice"
      :lastNetPrice="lastNetPrice"
      :currency="currency"
      @change="managePriceAdjusments"
      @close="closePriceAdjusments"
    />

    <modal
      v-if="pdfDataUrl"
      :show.sync="showPreviewPickupSign"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pt-1"
    >
      <template slot="header">
        <h4 class="subtitle mb-0" id="BlackoutDate">Pickup Sign</h4>
      </template>

      <iframe
        :src="`${pdfDataUrl}#zoom=100`"
        width="100%"
        height="600px"
      ></iframe>
    </modal>
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  RatesAPI,
  FlightsAPI,
  PassengersAPI,
  QuotesAPI
} from "../../../core/api";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import AddCustomer from "../../../components/transfer/AddCustomer.vue";
import NewPassenger from "../../../components/passengers/NewPassenger.vue";
import EditPassenger from "../../../components/passengers/EditPassenger.vue";
import Charges from "../../../components/price-composition/Charges.vue";
import ManageExtraCharges from "../../../components/price-composition/ManageExtraCharges.vue";
import ManageDiscounts from "../../../components/price-composition/ManageDiscounts.vue";
import ManagePriceAdjustments from "../../../components/price-composition/ManagePriceAdjustments.vue";
import Services from "../../../components/transfer/Services.vue";
import FlightNumberInput from "../../../components/transfer/flightValidation/FlightNumberInput.vue";
import FlightDetails from "../../../components/transfer/flightValidation/FlightDetails.vue";
import {
  required,
  maxLength,
  decimal,
  numeric,
  alphaNum,
  minValue,
  requiredIf
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect,
  MessageBox,
  Message
} from "element-ui";
import { cloneDeep, isEqual, isNumber } from "lodash";
import { FadeTransition } from "vue2-transitions";
import Papa from "papaparse";
import { getAirportName } from "../../../helpers/reservation.helpers";
import {
  getGenderByTitle,
  getPassengerToRegister,
  parseContentFile,
  validateHeadersFile,
  validateRow
} from "../../../core/services/passenger.service";
import {
  generateMessageToNotify,
  getPickupDate,
  getPickupTime
} from "../services/flight.services";

import {
  setSigOut,
  goBack,
  isUserAuthorized
} from "../../../helpers/commons.helpers";
import debounce from "lodash.debounce";
import { FileService } from "../../../core/services";
import {
  dealNumberValidationMessage,
  fromValidationMessage,
  passengersCountValidationMessage,
  toValidationMessage
} from "../services/validation.service";
import {
  FIELDS_PASSENGER,
  FIELDS_PASSENGER_VIEW,
  MINIMUM_SELECT
} from "../../../core/constants";
import {
  getStatusClass,
  canCancelQuote,
  canConvertQuote,
  canDownloadQuotePDF,
  canDuplicateQuote
} from "../services/status.service";
import {
  buildPassengerTitleByGender,
  formatCustomerType,
  formatPassengerTableHeaders,
  formatPassengerType,
  formatPickupDate,
  formatQuoteDate,
  formatQuoteStatus,
  formatQuoteTime,
  formatServiceCategory,
  formatSourceProvider,
  formatTransferType,
  getTransferTypeLabel
} from "../services/format.service";
import {
  autocompleteLocations,
  formatLocationForRequest,
  getLocationIcon,
  getTypeLocation
} from "../services/location.service";
import { alphabeticallySort } from "../services/client.service";
import {
  buildUtcPickupDateTime,
  handleBlackoutConfirmation,
  handleCutOffConfirmation
} from "../services/quote.service";
import {
  calculateTotalPrice,
  calculateCommissionAmount,
  calculateTotalDiscounts,
  calculateTotalExtraGrossPrice,
  calculateTotalExtrasNetPrice,
  calculateTotalGrossPrice,
  calculateTotalNetPrice,
  calculateTotalNetProfit,
  getCommissionByCustomer,
  isSamePriceComposition,
  isSameSurchargesComposition
} from "../../pricing";
import {
  cancelQuote,
  convertToBooking,
  downloadQuotePDF,
  duplicateQuote
} from "../services/alerts.service";
import {
  populateBranchOptions,
  populateClient,
  populateLocation,
  populateResponsibleUser,
  populateService,
  populateSupplierOptions
} from "../services/populate.service";
import { TRANSFER_OPTIONS } from "../constants/commons.constants";
import { TransferPricingAPI } from "../../../core/api/transfer-pricing.api.js";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditQuote",
  data() {
    return {
      quote: {
        origin: {
          name: "",
          lng: null,
          lat: null,
          googlePlaceId: "",
          country: "",
          metadata: {}
        },
        destination: {
          name: "",
          lng: null,
          lat: null,
          googlePlaceId: "",
          country: "",
          metadata: {}
        },
        quoteNumber: "",
        pickupDate: "",
        pickupTime: "",
        passengersCount: 0,
        childSeatsCount: 0,
        type: "ARRIVAL",
        supplier: null,
        branch: null,
        service: null,
        vehicle: null,
        routerReference: "",
        customer: null,
        pickupSign: {
          format: "CUSTOM",
          text: "",
          link: ""
        },
        specialRequirements: "",
        status: "NEW",
        surcharges: [],
        routeMetrics: {
          distance: 0,
          duration: 0
        },
        agent: null,
        passenger: null,
        metadata: {},
        passengers: [],
        dealNumber: "",
        pricing: {
          net_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          base_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          gross_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          net_profit: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          sale_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          discounts: [],
          extras: [],
          totals: {
            discounts: 0.0,
            extras: {
              gross_price: 0.0,
              net_price: 0.0,
              net_profit: 0.0
            },
            net_price: 0.0,
            gross_price: 0.0,
            net_profit: 0.0
          },
          reason_adjustment: ""
        },
        responsible: {
          type: "Users",
          ref: ""
        },
        notificaition: {
          configTag: "rhomtrip_internal",
          configRef: null
        },
        commissions: {
          payment_processor: {
            amount: 0.0,
            percentage: 0.0
          },
          platform: {
            amount: 0.0,
            percentage: 0.0
          }
        },
        source: {
          origin: "RhomTrip Internal",
          type: "INTERNAL",
          provider: "RHOMTRIP",
          channel: "SYSTEM",
          medium: "APP"
        },
        flight: null
      },
      pickupDate: "",
      TRANSFER_OPTIONS,
      services: [],
      serviceAux: [],
      all_services: [],
      branches: [],
      customer: {
        _id: "",
        first_name: "",
        last_name: "",
        company_name: "",
        mark_up: 32,
        type_markup: "",
        email: "",
        phone: "",
        type: ""
      },
      minimumSelect: MINIMUM_SELECT,
      suppliersOptions: [],
      branchesOptions: [],
      supplierFilter: "",
      branchFilter: "",
      branch: null,
      supplier: null,
      loading: false,
      optionsFrom: [],
      customers: [],
      optionsTo: [],
      service: null,
      requestType: "one_way",
      reservationCopy: {},
      currency: {
        symbol: "",
        code: ""
      },
      copyData: false,
      modalCustomer: false,
      quoteId: null,
      loaderService: "SEARCHING",
      isInitialized: false,
      showRates: false,
      debouncedRequote: null,
      customerId: null,
      route: null,
      mode: "view",
      createdAt: "",
      showDiscountModal: false,
      showExtrasModal: false,
      responsible: null,
      showNewPassengerModal: false,
      fieldsPassenger: FIELDS_PASSENGER,
      passengers: [],
      showEditPassengerModal: false,
      selectedRows: [],
      tempPassenger: null,
      passengerIndex: null,
      fieldsPassengerView: FIELDS_PASSENGER_VIEW,
      showPriceAdjusments: false,
      lastGrossPrice: 0,
      lastNetPrice: 0,
      pdfDataUrl: null,
      showPreviewPickupSign: false,
      noImage: require("rhomtrip_assets/src/img/no-image-available.png"),
      routerReference: {
        transferType: "arrival",
        value: ""
      },
      quoteSaveRequested: false,
      bookingType: "Transfers",
      cancellationPolicy: {},
      requoteStatus: "CALCULATED",
      loading: false,
      flightType: "NONE",
      flight: null,
      airport: null,
      flightValidationRoles: {},
      isRequoted: false
    };
  },
  watch: {
    customerOptions: {
      handler: function(current, old) {
        this.customers = current;
      },
      deep: true
    }
  },
  async created() {
    this.debouncedRequote = debounce(this.requote, 500);
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Quotes",
        to: "/quotes"
      },
      {
        text: "Quote Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.getSesion();
    this.isInitialized = false;
    this.quoteId = this.$route.params.id;
    this.setLoad(true);
    await this.loadQuote(this.quoteId);
    this.$nextTick(() => {
      this.isInitialized = true;
    });
    this.setLoad(false);
    this.customers = this.customerOptions;
  },
  methods: {
    getAirportName,
    ///New
    fromValidationMessage,
    toValidationMessage,
    formatQuoteStatus,
    getStatusClass,
    formatQuoteDate,
    formatQuoteTime,
    formatCustomerType,
    formatServiceCategory,
    buildPassengerTitleByGender,
    formatPassengerType,
    formatPassengerTableHeaders,
    autocompleteLocations,
    formatSourceProvider,
    passengersCountValidationMessage,
    dealNumberValidationMessage,
    getTransferTypeLabel,
    getLocationIcon,
    convertToBooking,
    downloadQuotePDF,
    duplicateQuote,
    cancelQuote,
    populateService,
    formatTransferType,
    isNumber,
    canCancelQuote,
    canConvertQuote,
    canDownloadQuotePDF,
    canDuplicateQuote,
    async loadQuote(quoteId) {
      try {
        let { data } = await QuotesAPI.getQuoteById(quoteId, this.sesion.token);
        if (data) {
          // Populate quote details
          this.quote.type = data.type;
          this.quote.quoteNumber = data.quoteNumber;
          this.quote.pickupDate = formatPickupDate(data.pickupDate);
          this.quote.pickupTime = data.pickupTime;
          this.quote.passengersCount = data.passengersCount;
          this.quote.childSeatsCount = data.childSeatsCount
            ? data.childSeatsCount
            : 0;
          this.quote.origin = data.origin;
          this.quote.destination = data.destination;
          // Populate customer details
          this.quote.customer = data.customer ? data.customer._id : null;
          this.quote.agent = data.agent ? data.agent._id : null;
          this.customer = this.quote.agent
            ? populateClient(data.agent)
            : populateClient(data.customer);
          this.customerId = this.customer ? this.customer._id : null;

          // Populate flight details
          if (["ARRIVAL", "DEPARTURE"].includes(data.type)) {
            this.flightType = data.type;
          }
          // Populate location options
          this.optionsFrom = populateLocation(data.origin, data.type, "origin");
          this.optionsTo = populateLocation(
            data.destination,
            data.type,
            "destination"
          );
          // Populate supplier details
          if (data.supplier) {
            this.supplier = data.supplier;
            this.quote.supplier = data.supplier._id;
            this.suppliersOptions = populateSupplierOptions(data.supplier);
          }
          // Populate branch details
          if (data.branch) {
            this.branch = data.branch;
            this.quote.branch = data.branch._id;
            this.branchesOptions = populateBranchOptions(data.branch);
          }
          // Populate service details
          this.service = populateService(
            data.supplier,
            data.service,
            data.pricing,
            data.surcharges
          );
          if (this.service) {
            this.quote.service = this.service._id;
            this.currency = this.service.currency;
          }
          this.quote.vehicle = data.vehicle;
          this.quote.routerReference = data.routerReference;
          this.quote.pickupSign = data.pickupSign;
          this.quote.specialRequirements = data.specialRequirements;
          this.quote.status = data.status;
          this.quote.surcharges = data.surcharges;
          this.quote.routeMetrics = data.routeMetrics;
          this.quote.passenger = data.passenger;
          this.quote.metadata = data.metadata;
          this.quote.passengers = data.passengers;
          this.quote.dealNumber = data.dealNumber;
          this.quote.pricing = data.pricing;

          if (data.responsible) {
            this.quote.responsible.ref = data.responsible.ref._id;
            this.quote.responsible.type = data.responsible.type;
            this.responsible = populateResponsibleUser(
              data.responsible.ref,
              data.responsible.type
            );
          }
          this.quote.notificaition = data.notificaition;
          this.quote.commissions = data.commissions;
          this.quote.source = data.source;
          this.quote.flight = data.flight;
          this.createdAt = data.createdAt;
          this.quoteCopy = cloneDeep(this.quote);
          return false;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
          return da;
        }
      } catch (error) {
        console.error("Error fetching quote data:", error);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    changeSupplier(value) {
      if (value !== "") {
        this.branchFilter = "";
        this.branchesAux = this.branchesOptions.filter(branch => {
          return branch.supplier === value;
        });
        this.serviceAux = this.all_services.filter(service => {
          return this.branchesAux
            .map(branch => branch._id)
            .includes(service.branchId);
        });
      } else {
        this.branchFilter = "";
        this.serviceAux = this.services;
      }
    },
    changeBranch(value) {
      if (value !== "") {
        this.quote.driver = null;
        this.serviceAux = this.all_services.filter(service => {
          return service.branchId === value;
        });
      } else {
        if (this.supplierFilter) {
          this.branchesAux = this.branchesOptions.filter(branch => {
            return branch.supplier === this.supplierFilter;
          });
          this.serviceAux = this.all_services.filter(service => {
            return this.branchesAux
              .map(branch => branch._id)
              .includes(service.branchId);
          });
        }
      }
    },
    async saveQuote(route = null) {
      if (!this.$v.quote.$invalid) {
        let notChanged = isEqual(this.quote, this.quoteCopy);
        if (notChanged) {
          this.$router.push("/quotes");
          return;
        }

        let quote = cloneDeep(this.quote);
        quote.pickupDate = buildUtcPickupDateTime(
          quote.pickupDate,
          quote.pickupTime
        );
        await this.updateQuote(this.quoteId, quote, route);
      } else {
        this.$v.quote.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateQuote(quoteId, quote, route = null) {
      try {
        this.quoteSaveRequested = false;
        this.setLoad(true);
        let { data } = await QuotesAPI.updateQuoteById(
          quoteId,
          quote,
          this.sesion.token
        );
        this.setLoad(false);
        this.quoteSaveRequested = true;
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quotes has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/quotes");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.quoteSaveRequested = false;
        this.handleError(
          error,
          "There was an error saving your quote, please try again"
        );
      }
    },
    getSelectServices(service, element) {
      if (service) {
        return service._id === element._id;
      }
      return false;
    },
    async handleBlackoutService(confirmed, service) {
      if (confirmed) {
        await this.handleServiceSelection(service);
      } else {
        this.service = null;
        this.quote.service = null;
      }
    },
    async handleCutOff(confirmed, service) {
      if (confirmed) {
        await this.applyServiceToQuote(service, this.customer);
      } else {
        this.service = null;
        this.quote.service = null;
      }
    },
    async handleServiceSelection(service) {
      if (this.service) {
        const isDifferentServiceId = this.service._id !== service._id;
        const samePriceComposition = isSamePriceComposition(
          this.service.basePriceComposition,
          service.basePriceComposition
        );
        const sameSurchargesComposition = isSameSurchargesComposition(
          this.service.surcharges,
          service.surcharges
        );
        if (
          isDifferentServiceId ||
          !samePriceComposition ||
          !sameSurchargesComposition
        ) {
          await this.validateAndApplyService(service);
        }
        return;
      }
      await this.validateAndApplyService(service);
      return;
    },
    async processServiceSelection(service) {
      try {
        if (service.blackout) {
          await handleBlackoutConfirmation(service, this.handleBlackoutService);
        } else {
          await this.handleServiceSelection(service);
        }
      } catch (error) {
        this.service = null;
        this.quote.service = null;
      }
    },
    async validateAndApplyService(service) {
      const isCutoffTimeApplied = service.isCutoffTimeApplied;
      if (!isCutoffTimeApplied) {
        await this.applyServiceToQuote(service, this.customer);
      } else {
        await handleCutOffConfirmation(service, this.handleCutOff);
      }
    },
    async applyServiceToQuote(service, customer) {
      this.service = service;
      this.quote.supplier = service.supplierId;
      this.quote.branch = service.branchId;
      this.quote.service = service._id;
      this.quote.vehicle = service.vehicle._id;
      this.isRequoted = true;
      this.quote.surcharges = service.surcharges;

      let base_price = parseFloat(service.base_price.toFixed(2));
      this.quote.pricing.base_price.amount = base_price;
      this.quote.pricing.base_price.last_amount = base_price;
      this.quote.pricing.base_price.composition = service.basePriceComposition;

      let sale_price = parseFloat(service.sale_price.toFixed(2));
      this.quote.pricing.sale_price.amount = sale_price;
      this.quote.pricing.sale_price.last_amount = sale_price;

      let base_price_amount = calculateTotalPrice(
        base_price,
        service.surcharges,
        "net"
      );
      let net_price = parseFloat(base_price_amount.toFixed(2));
      this.quote.pricing.net_price.amount = net_price;
      this.quote.pricing.net_price.last_amount = net_price;

      this.currency.symbol = service.currency.symbol;
      this.currency.code = service.currency.code;
      if (customer) {
        this.calculePriceByCustomer(
          this.quote.pricing.net_price.last_amount,
          customer.mark_up,
          customer.type_markup,
          true
        );
      }
    },
    buildRateOptionsRequestBody() {
      return {
        passengersCount: this.quote.passengersCount,
        origin: formatLocationForRequest(this.quote.origin),
        destination: formatLocationForRequest(this.quote.destination),
        pickup_date: this.quote.pickupDate,
        pickup_time: this.quote.pickupTime,
        type_request: this.requestType,
        hours: this.quote.type === "HOURLY" ? this.quote.routerReference : 0,
        arrival: this.flightType === "ARRIVAL",
        childSeatsCount: this.quote.childSeatsCount,
        serviceType: "TRANSFER",
        source: "rhombus-v1"
      };
    },
    async getBookingOptions() {
      try {
        let payload = this.buildRateOptionsRequestBody();
        this.loaderService = "SEARCHING";
        let { data } = await TransferPricingAPI.getTransferPricingQuotation(
          payload,
          this.sesion.token
        );
        if (data) {
          this.branchFilter = "";
          this.supplierFilter = "";
          this.quote.origin.lat = data.origin.lat;
          this.quote.origin.lng = data.origin.lng;
          this.quote.destination.lat = data.destination.lat;
          this.quote.destination.lng = data.destination.lng;
          this.quote.routeMetrics.distance = data.distance;
          this.quote.routeMetrics.duration = data.duration;

          this.timezone = data.timezone;
          this.services = data.services;
          this.all_services = data.all_services;
          this.serviceAux = this.services;
          this.suppliersOptions = data.suppliers;
          this.branchesOptions = data.branches;
          this.loaderService = this.serviceAux.length ? "RESULTS" : "NOT_FOUND";
        } else {
          this.services = [];
          this.suppliersOptions = [];
          this.branchesOptions = [];
          this.loaderService = "NOT_FOUND";
        }
      } catch (error) {
        this.services = [];
        this.suppliersOptions = [];
        this.branchesOptions = [];
        this.loaderService = "NOT_FOUND";
      } finally {
        if (this.services.length === 0) {
          this.service = null;
          this.quote.service = null;
        }
        return;
      }
    },
    async getLocationFrom(input) {
      let type = getTypeLocation(this.quote.type, "from");
      this.loading = true;
      this.optionsFrom = await autocompleteLocations(input, type);
      this.loading = false;
    },
    async getLocationTo(input) {
      let type = getTypeLocation(this.quote.type, "to");
      this.loading = true;
      this.optionsTo = await autocompleteLocations(input, type);
      this.loading = false;
    },
    async getCustomer(input = "") {
      if (input !== "" && input.length > 2) {
        this.loading = true;
        this.customers = this.customerOptions.filter(customer => {
          const name = `${customer.first_name} ${customer.last_name}`;
          const companyName = customer.company_name || "";
          return (
            name.toLowerCase().includes(input.trim().toLowerCase()) ||
            companyName.toLowerCase().includes(input.trim().toLowerCase())
          );
        });
        this.loading = false;
      } else {
        this.customers = this.customerOptions;
      }
    },
    copyDataCustomer() {
      let passengersCount = this.quote.passengers.length;
      if (passengersCount >= 0 && passengersCount <= 1) {
        this.quote.passengers = [
          {
            _id: null,
            reference: uuidv4(),
            firstName: this.customer.first_name,
            lastName: this.customer.last_name,
            fullName: `${this.customer.first_name} ${this.customer.last_name}`,
            email: this.customer.email,
            phone: this.customer.phone,
            gender: this.customer.gender,
            type: "ADULT",
            primary: true,
            notify: this.customer.email ? true : false,
            flightNumber: this.quote.routerReference
          }
        ];
        this.quote.pickupSign.format = "CUSTOM";
        this.quote.pickupSign.text = `${this.buildPassengerTitleByGender(
          this.customer.gender
        )} ${this.customer.first_name} ${this.customer.last_name}`;
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.quote.customer = customer._id;
        this.customerId = customer._id;
        this.setCustomerOptions(this.customerOptions.concat([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status) {
        this.quote.customer = this.customer._id;
      }
    },
    async selectCustomer(customerId) {
      if (!this.service) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We have detected that you have not selected any available service.`,
          icon: "flaticon-warning-1"
        });
        this.quote.customer = null;
        this.customerId = null;
        return;
      }
      this.customer = this.customers.find(customer => {
        return customer._id === customerId;
      });
      if (this.customer) {
        this.copyData = true;
        if (["travel_access"].includes(this.customer.type)) {
          this.quote.customer = this.customer.owner;
          this.quote.agent = this.customer._id;
        } else {
          this.quote.customer = this.customer._id;
          this.quote.agent = null;
        }
        this.calculePriceByCustomer(
          parseFloat(this.quote.pricing.net_price.last_amount.toFixed(2)),
          this.customer.mark_up,
          this.customer.type_markup,
          true
        );
        this.passengers = await this.getPassengersByCustomerId(customerId);
      }
    },
    calculePriceByCustomer(netPrice, markUp, markUpType, customerExists) {
      let grossPrice = this.getGroosPrice(
        netPrice,
        markUp,
        markUpType,
        customerExists
      );

      let totalGrossPrice = calculateTotalPrice(
        parseFloat(grossPrice.toFixed(2)),
        this.quote.surcharges,
        "gross"
      );
      this.quote.pricing.gross_price.amount = parseFloat(
        totalGrossPrice.toFixed(2)
      );

      this.quote.pricing.gross_price.last_amount = this.quote.pricing.gross_price.amount;

      let netProfit = this.quote.pricing.gross_price.last_amount - netPrice;
      this.quote.pricing.net_profit.amount = parseFloat(netProfit.toFixed(2));
      this.quote.pricing.net_profit.last_amount = this.quote.pricing.net_profit.amount;

      this.populatePricing(
        this.quote.pricing.extras,
        this.quote.pricing.discounts
      );
    },
    getGroosPrice(netPrice, markUp, markUpType, customerExists) {
      if (customerExists) {
        return markUpType === "markup"
          ? netPrice / (1 - markUp / 100)
          : netPrice * (1 - markUp / 100);
      } else {
        return netPrice / 0.7;
      }
    },
    async getRatesWithTheOrigin(value) {
      try {
        let direction =
          this.quote.type !== "HOURLY"
            ? value !== "" && this.quote.destination.name !== ""
            : value !== "";
        let date = this.quote.pickupDate !== "" && this.quote.pickupTime !== "";
        let passengersCount = this.quote.passengersCount;
        if (direction && date && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheDestination(value) {
      try {
        let direction =
          this.quote.type !== "HOURLY"
            ? value !== "" && this.quote.origin.name !== ""
            : this.quote.origin.name !== "";
        let date = this.quote.pickupDate !== "" && this.quote.pickupTime !== "";
        let passengersCount = this.quote.passengersCount;
        if (direction && date && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupDate(value) {
      try {
        if (!this.isInitialized) return;
        let direction =
          this.quote.type !== "HOURLY"
            ? this.quote.destination.name !== "" &&
              this.quote.origin.name !== ""
            : this.quote.origin.name !== "";
        let date = value !== "" && this.quote.pickupTime !== "";
        let passengersCount = this.quote.passengersCount;
        if (direction && date && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupTime(value) {
      try {
        if (!this.isInitialized) return;
        let direction =
          this.quote.type !== "HOURLY"
            ? this.quote.destination.name !== "" &&
              this.quote.origin.name !== ""
            : this.quote.origin.name !== "";
        let date = this.quote.pickupDate !== "" && value !== "";
        let passengersCount = this.quote.passengersCount;
        if (direction && date && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheNumberPassengers(value) {
      try {
        let direction =
          this.quote.type !== "HOURLY"
            ? this.quote.destination.name !== "" &&
              this.quote.origin.name !== ""
            : this.quote.origin.name !== "";
        let date = this.quote.pickupDate !== "" && this.quote.pickupTime !== "";
        let passengersCount = parseInt(value);
        if (direction && date && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheHourly(value) {
      try {
        let direction =
          this.quote.type !== "HOURLY"
            ? value !== "" && this.quote.origin.name !== ""
            : this.quote.origin.name !== "";
        let date = this.quote.pickupDate !== "" && this.quote.pickupTime !== "";
        let passengersCount = this.quote.passengersCount;
        if (direction && date && passengersCount > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    getBranchName(branchId) {
      let branch = this.branchesOptions.find(branch => branch._id === branchId);
      if (branch) {
        return branch.name;
      }
      return "Destination Name";
    },
    getSupplierName(supplierId) {
      let supplier = this.suppliersOptions.find(
        supplier => supplier._id === supplierId
      );
      if (supplier) {
        return supplier.businessDetails.name;
      }
      return "Supplier Name";
    },
    getSupplierNotes(supplierId) {
      let supplier = this.suppliersOptions.find(
        supplier => supplier._id === supplierId
      );
      if (supplier) {
        return supplier.notes;
      }
      return "";
    },
    async requote() {
      this.requoteStatus = "RECALCULATED";
      this.showRates = true;
      this.branchFilter = "";
      this.supplierFilter = "";
      this.suppliersOptions = [];
      this.branchesOptions = [];
      this.branches = [];
      if (this.isRequoteNeeded) {
        this.quote.service = null;
        this.service = null;
        this.quoteCopy = cloneDeep(this.quote);
      }
      await this.getBookingOptions();
      let serviceId = this.service ? this.service._id : null;
      let currentService = this.getServiceById(serviceId, this.services);
      if (currentService) {
        this.processServiceSelection(currentService);
      }
      this.requoteStatus = "CALCULATED";
    },
    storeQuote(route = null) {
      if (this.requoteStatus === "CALCULATED") {
        if (this.isRequoteNeeded) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "Please requote the service before saving the quote with the new service.",
            icon: "flaticon-warning-1"
          });
          return;
        }
        this.saveQuote(route);
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `The quote can't be updated as it is currently being re-quoted for transfer.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    getServiceById(serviceId, services = []) {
      return services.find(service => service._id === serviceId) || null;
    },
    getCustomerLabel(customer) {
      if (["travel_agency", "travel_access"].indexOf(customer.type) > -1) {
        return `${customer.company_name} - ${customer.first_name} ${customer.last_name}`;
      } else {
        return `${customer.first_name} ${customer.last_name}`;
      }
    },
    async populateOringData(from) {
      if (from) {
        let element = this.optionsFrom.find(item => item.select === from);
        if (element) {
          let location = element.location;
          this.quote.origin.lng = location.lng !== 0 ? location.lng : null;
          this.quote.origin.lat = location.lat !== 0 ? location.lat : null;
          this.quote.origin.googlePlaceId = element.place_id;
          if (element.type === "airport") {
            this.flightType = "ARRIVAL";
            this.quote.origin.country = element.country_code;
            this.quote.origin.metadata = element.metadata;
            this.airport = element.metadata ? element.metadata : {};
          }
        }
      }
    },
    async populateDestinationData(to) {
      if (to) {
        let element = this.optionsTo.find(item => item.select === to);
        if (element) {
          let location = element.location;
          this.quote.destination.lng = location.lng !== 0 ? location.lng : null;
          this.quote.destination.lat = location.lat !== 0 ? location.lat : null;
          this.quote.destination.googlePlaceId = element.place_id;
          if (element.type === "airport") {
            this.flightType = "DEPARTURE";
            this.quote.destination.country = element.country_code;
            this.quote.destination.metadata = element.metadata;
            this.airport = element.metadata ? element.metadata : {};
          }
        }
      }
    },
    async selectFrom(from) {
      await this.populateOringData(from);
      await this.getRatesWithTheOrigin(from);
    },
    async selectTo(to) {
      await this.populateDestinationData(to);
      await this.getRatesWithTheDestination(to);
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    openDiscountModal() {
      this.showDiscountModal = true;
    },
    closeDiscountModal() {
      this.showDiscountModal = false;
    },
    manageDiscounts(discounts = []) {
      this.quote.pricing.discounts = discounts;
      this.populatePricing(
        this.quote.pricing.extras,
        this.quote.pricing.discounts
      );
      this.showDiscountModal = false;
    },
    openExtrasModal() {
      this.showExtrasModal = true;
    },
    closeExtrasModal() {
      this.showExtrasModal = false;
    },
    manageExtras(extras = []) {
      this.quote.pricing.extras = extras;
      this.populatePricing(
        this.quote.pricing.extras,
        this.quote.pricing.discounts
      );
      this.showExtrasModal = false;
    },
    populatePricing(extras = [], discounts = []) {
      //Calculate Total Extras Net Price
      this.quote.pricing.totals.extras.net_price = calculateTotalExtrasNetPrice(
        extras
      );
      //Calculate Total Extra Gross Price
      this.quote.pricing.totals.extras.gross_price = calculateTotalExtraGrossPrice(
        extras
      );
      //Calculate Total Extras Net Profit
      this.quote.pricing.totals.extras.net_profit =
        this.quote.pricing.totals.extras.gross_price -
        this.quote.pricing.totals.extras.net_price;

      //Calculate Total Discounts
      this.quote.pricing.totals.discounts = calculateTotalDiscounts(discounts);

      //Calculate Total Net Price
      this.quote.pricing.totals.net_price = calculateTotalNetPrice([
        this.quote.pricing.totals.extras.net_price,
        this.quote.pricing.net_price.last_amount
      ]);

      //Calculate Total Gross Price
      let totalsGrossPrice = calculateTotalGrossPrice([
        this.quote.pricing.totals.extras.gross_price,
        this.quote.pricing.gross_price.last_amount
      ]);
      this.quote.pricing.totals.gross_price =
        totalsGrossPrice - this.quote.pricing.totals.discounts;

      //Calculate Commissions Platform
      this.quote.commissions.platform.percentage = getCommissionByCustomer(
        this.customer
      );

      this.quote.commissions.platform.amount = calculateCommissionAmount(
        this.quote.pricing.totals.gross_price,
        this.quote.commissions.platform.percentage
      );

      //Calculate Total Net profit
      this.quote.pricing.totals.net_profit = calculateTotalNetProfit(
        this.quote.pricing.totals.gross_price,
        this.quote.pricing.totals.net_price,
        this.quote.commissions.platform.amount,
        this.quote.commissions.payment_processor.amount
      );
    },
    parsePrice(price) {
      return Number.parseFloat(price).toFixed(2);
    },
    async getFlightsInformationByIdent(ident) {
      try {
        let { data } = await FlightsAPI.getFlightsInformationByIdent(
          ident,
          this.sesion.token
        );
        if (data.status) {
          window.open(
            `https://www.flightaware.com/live/flight/${data.data.ident}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We couldn't display the details of your flight. Please try again later.`,
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We couldn't display the details of your flight. Please try again later.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    addAdjustments(adjustment) {
      if (adjustment === "extraCharges") {
        this.openExtrasModal();
      } else if (adjustment === "discounts") {
        this.openDiscountModal();
      } else {
        this.openPriceAdjustments();
      }
    },
    getContactNumber(status, phoneNumbers = []) {
      let contactNumber = phoneNumbers.find(
        phone => phone.preferred === status
      );
      if (contactNumber) {
        return contactNumber.number;
      } else {
        return "";
      }
    },
    closeNewPassengerModal(status) {
      this.showNewPassengerModal = false;
    },
    closeEditPassengerModal() {
      this.showEditPassengerModal = false;
      this.tempPassenger = null;
      this.passengerIndex = null;
    },
    openEditPassengerModal(passenger, passengerIdentifier) {
      this.showEditPassengerModal = true;
      this.tempPassenger = passenger;
      this.passengerIndex = passengerIdentifier;
    },
    addNewPassenger() {
      if (this.quote.passengers.length < this.quote.passengersCount) {
        if (!this.customerId || !this.service) {
          let message = !this.service
            ? "We have detected that you have not selected any customer."
            : "We have detected that you have not selected any available service.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
        } else {
          this.showNewPassengerModal = true;
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed PAX. Please adjust the number of PAX to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    async removePassenger(index, primary) {
      if (!primary) {
        let { value } = await Swal.fire({
          title: "Remove Passenger",
          html:
            "Are you sure you want to <strong>Remove</strong> the selected Passenger?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          this.quote.passengers.splice(index, 1);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The PAX has been removed",
            icon: "flaticon-check-3"
          });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "You cannot delete a PAX marked as primary. To delete this PAX, please assign another PAX as the primary.",
          icon: "flaticon-check-3"
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async copyPassengerData(passenger) {
      try {
        let text = `Name: ${passenger.fullName}\nPhone: ${passenger.phone}\nEmail: ${passenger.email}\n`;
        let clipboard = await navigator.clipboard.writeText(text);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The data has been copied to the clipboard",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    makePassengerAsDefault(index) {
      if (index >= 0) {
        this.quote.passengers = this.quote.passengers.map(passenger => {
          passenger.primary = false;
          return passenger;
        });
        this.quote.passengers[index].primary = true;
        if (this.quote.pickupSign.format === "CUSTOM") {
          this.quote.pickupSign = this.getPickupSignByPrimaryPassenger(
            this.quote.passengers
          );
        }
      }
    },
    async addPassenger(passenger) {
      if (passenger) {
        if (this.quote.passengers.length === 0) {
          passenger.primary = true;
          passenger.notify = passenger.email ? true : false;
          this.quote.passengers.push(passenger);
          this.quote.pickupSign.format = "CUSTOM";
          this.quote.pickupSign.text = `${this.buildPassengerTitleByGender(
            passenger.gender
          )} ${passenger.firstName} ${passenger.lastName}`;
        } else {
          this.quote.passengers.push(passenger);
        }
        this.passengers = passenger._id
          ? await this.getPassengersByCustomerId(this.customerId)
          : this.passengers;
      }
    },
    upadtePassenger(passenger) {
      if (passenger) {
        this.quote.passengers.splice(this.passengerIndex, 1, passenger);
        if (this.quote.pickupSign.format === "CUSTOM") {
          this.quote.pickupSign = this.getPickupSignByPrimaryPassenger(
            this.quote.passengers
          );
        }
      }
      this.passengerIndex = 0;
      this.tempPassenger = null;
    },
    async getPassengersByCustomerId(customerId) {
      try {
        let { data } = await PassengersAPI.getPassengersByCustomerId(
          customerId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    importPassengers() {
      let passengersCount = this.quote.passengersCount;
      if (this.quote.passengers.length < passengersCount) {
        if (!this.customerId || !this.service) {
          let message = !this.service
            ? "We have detected that you have not selected any customer."
            : "We have detected that you have not selected any available service.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
        } else {
          this.$refs.fileInput.click();
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "We are sorry, but you have exceeded the maximum number of allowed PAX. Please adjust the number of PAX to proceed.",
          icon: "flaticon-warning-1"
        });
      }
    },
    validateContentFile(rows = []) {
      return rows.map(row => validateRow(row)).every(row => row === true);
    },
    bulkPassengers(event) {
      try {
        const [file] = event.target.files;
        if (file) {
          this.readFile(file);
          this.$refs.fileInput.value = null;
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the import again",
            icon: "flaticon-warning-1"
          });
          this.$refs.fileInput.value = null;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The PAX data couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
        this.$refs.fileInput.value = null;
      }
    },
    readFile(file) {
      try {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: async results => {
            let headers = results.meta.fields;
            let content = parseContentFile(results.data);
            let isValidFile =
              !validateHeadersFile(headers) &&
              this.validateContentFile(content);
            let passengersCount = this.quote.passengersCount;
            let diffPassengers = passengersCount - this.quote.passengers.length;
            if (diffPassengers > 0 && content.length <= diffPassengers) {
              if (isValidFile) {
                let localPassengers = getPassengerToRegister(
                  this.quote.passengers,
                  this.parsePassengers(content)
                );
                if (this.quote.passengers.length === 0) {
                  localPassengers[0].primary = true;
                }

                this.quote.passengers.push(...localPassengers);
                if (this.quote.pickupSign.format === "CUSTOM") {
                  this.quote.pickupSign = this.getPickupSignByPrimaryPassenger(
                    this.quote.passengers
                  );
                }
                let bulkPassengers = getPassengerToRegister(
                  this.passengers,
                  this.parsePassengers(content)
                );
                if (bulkPassengers.length) {
                  let registeredPassengers = await this.bulkCreatePassengers(
                    bulkPassengers,
                    this.customer._id,
                    this.customer.type
                  );
                  this.updatePassengerIdentifier(registeredPassengers);
                  this.passengers = await this.getPassengersByCustomerId(
                    this.customerId
                  );
                }
                this.$notify({
                  type: "success",
                  title: "Success!",
                  message: "PAX data has been imported successfully",
                  icon: "flaticon-check-3"
                });
              } else {
                this.$notify({
                  type: "warning",
                  title: "Warning!",
                  message:
                    "There is an error in the imported file, please check the data and try the import again",
                  icon: "flaticon-warning-1"
                });
              }
            } else {
              this.$notify({
                type: "warning",
                title: "Important!",
                message:
                  "We are sorry, but you have exceeded the maximum number of allowed PAX. Please adjust the number of PAX to proceed.",
                icon: "flaticon-warning-1"
              });
            }
          }
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The PAX data couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async bulkCreatePassengers(passengers = [], customerId, customerType) {
      try {
        let { data } = await PassengersAPI.bulkCreatePassengers(
          passengers,
          customerId,
          customerType,
          this.sesion.token
        );
        if (data.status) {
          return data.data.passengers;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    parsePassengers(passengers = []) {
      return passengers.map((passenger, index) => {
        return {
          _id: null,
          reference: uuidv4(),
          firstName: passenger.firstName,
          lastName: passenger.lastName,
          fullName: passenger.fullName,
          email: passenger.emailAddress,
          phone: this.parserContactNumber(passenger.contactNumber),
          gender: getGenderByTitle(passenger.title),
          type: passenger.type ? passenger.type : "ADULT",
          primary: false,
          notify: passenger.sendNotification
            ? passenger.sendNotification.toUpperCase() === "YES"
            : false,
          flightNumber: passenger.flightNumber
        };
      });
    },
    updatePassengerIdentifier(passengers = []) {
      this.quote.passengers = this.quote.passengers.map(passenger => {
        let element = passengers.find(
          item =>
            item.email === passenger.email && item.phone === passenger.phone
        );
        if (element) {
          passenger._id = element._id;
        }
        return passenger;
      });
    },
    getPickupSignByPrimaryPassenger(passengers = []) {
      let passenger = passengers.find(passenger => passenger.primary === true);
      return {
        format: "CUSTOM",
        text: passenger
          ? `${this.buildPassengerTitleByGender(passenger.gender)} ${
              passenger.firstName
            } ${passenger.lastName}`
          : "",
        link: ""
      };
    },
    parserContactNumber(contactNumber) {
      if (contactNumber) {
        contactNumber = contactNumber.replace(/[^0-9+]/g, "");
        if (contactNumber.charAt(0) !== "+") {
          contactNumber = `+${contactNumber}`;
        }
        return contactNumber;
      } else {
        return "";
      }
    },
    openPriceAdjustments() {
      this.lastGrossPrice = this.quote.pricing.gross_price.last_amount;
      this.lastNetPrice = this.quote.pricing.net_price.last_amount;
      this.showPriceAdjusments = true;
    },
    closePriceAdjusments() {
      this.lastGrossPrice = 0;
      this.lastNetPrice = 0;
      this.showPriceAdjusments = false;
    },
    managePriceAdjusments(pricing) {
      let { netProfit, grossPrice, netPrice, reason } = pricing;
      this.quote.pricing.net_price.last_amount = netPrice;
      this.quote.pricing.gross_price.last_amount = grossPrice;
      this.quote.pricing.net_profit.last_amount = netProfit;
      this.quote.pricing.reason_adjustment = reason;
      this.populatePricing(
        this.quote.pricing.extras,
        this.quote.pricing.discounts
      );
      this.showPriceAdjusments = false;
    },
    getAdjustmentsStatus(service, customer) {
      return service && customer ? true : false;
    },
    async recalculateExpiredReservation() {
      this.mode = "edit";
      await this.requote();
    },
    async uploadPickupSign(event) {
      this.$refs.pickupSign.click();
    },
    async readPickupSign(event) {
      this.quote.pickupSign.text = "";
      this.quote.pickupSign.format = "FILE";
      await this.uploadPickupSignFile(event);
    },
    async uploadPickupSignFile(event) {
      try {
        const [file] = event.target.files;
        if (file && file.type === "application/pdf") {
          if (file.size > 2 * 1024 * 1024) {
            event.preventDefault();
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The file can't be larger than 2MB",
              icon: "flaticon-remove"
            });
            this.clearfile();
          } else {
            this.pdfDataUrl = URL.createObjectURL(file);
            let fileData = FileService.generateResourceData(
              "/uploads/pdf/signs",
              file.name
            );
            let queryString = FileService.buildQueryString(fileData);
            let urlFile = await FileService.uploadResource(file, queryString);
            if (urlFile) {
              this.quote.pickupSign.link = urlFile;
            } else {
              this.$notify({
                type: "danger",
                title: "Error!",
                message:
                  "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
                icon: "flaticon-remove"
              });
            }
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the upload again",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The file couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    clearfile() {
      this.pdfDataUrl = null;
      this.quote.pickupSign = this.getPickupSignByPrimaryPassenger(
        this.quote.passengers
      );
    },
    openPreviewPickup() {
      this.showPreviewPickupSign = true;
    },
    closePreviewPickupSign(status) {
      this.showPreviewPickupSign = status;
      this.pdfDataUrl = null;
    },
    changeRouterReference(value) {
      this.routerReference = {
        transferType: this.quote.type,
        value
      };
    },
    getRouterReferenceValue(transferType, routerReference) {
      if (transferType === routerReference.transferType) {
        return routerReference.value;
      }
      return transferType === "HOURLY" ? 0 : "";
    },
    changeTransferType(type) {
      let routerReferenceValue = this.getRouterReferenceValue(
        type,
        this.routerReference
      );
      this.quote.routerReference = routerReferenceValue;
      this.requestType = type !== "HOURLY" ? "one_way" : "HOURLY";
    },
    getSourceOrigin(source) {
      if (source) {
        return source.origin;
      }
      return "";
    },
    goToPreviousPage() {
      goBack(this);
    },

    /**
     *
     * Quote Action Methods
     */
    async cancelQuoteById(quoteId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.cancelQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote can't be cancelled");
      } finally {
        await this.loadQuote(this.quoteId);
        this.$nextTick(() => {
          this.isInitialized = true;
        });
      }
    },
    async convertQuoteToBookingById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.createBookingFromQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const { _id: bookingId } = data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been converted to a Booking",
            icon: "flaticon-check-3"
          });
          this.$router.push(`/reservations/${bookingId}`);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be converted to a Booking",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote cannot be converted to a Booking");
      }
    },
    async duplicateQuoteById(quoteId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/quotes/new?sourceQuoteId=${quoteId}`);
    },
    async downloadQuoteById(quoteId, quoteNumber) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.downloadQuotePDFById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Quote(${quoteNumber}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteQuoteById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.deleteQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    /**
     * Flight Methods
     */

    /**
     * Handle flight selection and update reservation details
     * @param {Object} payload - The flight selection payload
     */
    async handleFlightSelection(payload) {
      const { flight, isAdjustingDateTime, flightType } = payload;
      this.flight = flight;
      this.flight.isAdjustingDateTime = isAdjustingDateTime;
      this.flight.flightType = flightType;
      this.quote.flight = cloneDeep(flight);
      this.changeRouterReference(this.quote.routerReference);
      if (isAdjustingDateTime) {
        const date =
          flightType === "ARRIVAL" ? flight.arrivaltime : flight.departuretime;
        const timezone =
          flightType === "ARRIVAL"
            ? flight.destination.timezone
            : flight.origin.timezone;

        this.quote.pickupDate = getPickupDate(date, timezone);
        if (flightType === "ARRIVAL") {
          this.quote.pickupTime = getPickupTime(date, timezone);
        }
        this.$notify({
          type: "info",
          title: "Important!",
          message: generateMessageToNotify(flightType),
          icon: "flaticon-notification-bell-outline-interface-symbol"
        });
        await this.requote();
      }
    },
    /**
     * Handle flight validation rules
     * @param {Object} rules - The flight validation rules
     */
    handleValidationState(rules) {
      this.flightValidationRoles = { ...rules };
    },
    /**
     * Reset flight details when flight number input changes
     */
    onFlightNumberInput(flightNumber) {
      if (!flightNumber) {
      }
    },
    buildRouterReferenceRules(quoteType) {
      if (["ARRIVAL", "DEPARTURE"].includes(quoteType)) {
        return {
          required: requiredIf(function(value) {
            return false;
          }),
          isFlightValid(value) {
            if (["ARRIVAL", "DEPARTURE"].includes(quoteType)) {
              if (!value) return true;
              const regex = /^[A-Z0-9]{1,3}?\d{1,5}[A-Z]?$/i;
              return regex.test(value.trim());
            }
            return true;
          },
          isValidate(value) {
            if (["ARRIVAL", "DEPARTURE"].includes(quoteType)) {
              let flightType = this.flightValidationRoles.flightType;
              if (["ARRIVAL", "DEPARTURE"].includes(flightType)) {
                return this.flightValidationRoles.isValidateFlightNumber;
              }
            }
            return true;
          }
        };
      } else if (quoteType === "STATION") {
        return {
          maxLength: maxLength(45)
        };
      } else if (quoteType === "PORT") {
        return {
          maxLength: maxLength(45)
        };
      } else if (quoteType === "HOURLY") {
        return {
          required: requiredIf(function() {
            return this.quote.type === "HOURLY";
          }),
          minValue: function(value) {
            if (this.quote.type !== "HOURLY") return () => true;
            return value > 1;
          }
        };
      } else {
        return {
          required: false
        };
      }
    },
    ...mapActions(["getSesion"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setCustomerOptions",
      "setItemsBread",
      "setDuplicatedReservation"
    ])
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [MessageBox.name]: MessageBox,
    [Message.name]: Message,
    flatPicker,
    VueTelInput,
    WSelect,
    AddCustomer: AddCustomer,
    NewPassenger,
    EditPassenger,
    Services,
    FadeTransition,
    Charges,
    ManageExtraCharges,
    ManagePriceAdjustments,
    ManageDiscounts,
    FlightNumberInput,
    FlightDetails
  },
  validations() {
    return {
      quote: {
        origin: {
          name: {
            required
          }
        },
        destination: {
          name: {
            required: requiredIf(function(value) {
              return this.quote.type !== "HOURLY";
            }),
            differentToOriginName: function(value) {
              if (this.quote.type === "HOURLY") return true;
              return value !== this.quote.origin.name;
            }
          }
        },
        pickupTime: {
          required
        },
        pickupDate: {
          required
        },
        passengersCount: {
          required,
          numeric,
          minValue: minValue(1),
          customValidator: function(value) {
            return this.quote.passengers.length <= value;
          }
        },
        routerReference: this.buildRouterReferenceRules(this.quote.type),
        customer: {
          required,
          alphaNum
        },
        service: {
          required
        },
        dealNumber: {
          maxLength: maxLength(10),
          customValidator: function(value) {
            if (value) {
              var regex = /^[A-Za-z]{3}-\d{5,6}$/;
              return regex.test(value);
            }
            return true;
          }
        },
        pricing: {
          net_price: {
            last_amount: {
              required,
              decimal,
              minValue: minValue(1)
            }
          },
          gross_price: {
            last_amount: {
              required,
              decimal,
              minValue: minValue(1)
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      "customerOptions",
      "sesion",
      "userRole",
      "load",
      "sigout",
      "itemsBread"
    ]),
    canUserUpdate() {
      return isUserAuthorized("QUOTES", this.userRole, "UPDATE");
    },
    canUserCreate() {
      return isUserAuthorized("QUOTES", this.userRole, "CREATE");
    },
    canUserChangeStatus() {
      return isUserAuthorized("QUOTES", this.userRole, "CHANGE_STATUS");
    },
    passenger: function() {
      let passengers = this.quote.passengers;
      let [passenger] =
        passengers.filter(p => p.primary === true) || passengers;
      return {
        gender: passenger ? passenger.gender : "",
        fullName: passenger ? passenger.fullName : "",
        email: passenger ? passenger.email : "",
        phone: passenger ? passenger.phone : ""
      };
    },
    isRequoteNeeded() {
      return this.quote.status === "EXPIRED" && !this.isRequoted;
    },
    includesExtraServices() {
      return this.quote.childSeatsCount > 0;
    },
    hasAvailableActions() {
      return (
        canConvertQuote(this.quote.status) ||
        canDownloadQuotePDF(this.quote.status) ||
        canDuplicateQuote(this.quote.status) ||
        canCancelQuote(this.quote.status)
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      let notChanged = isEqual(this.quote, this.quoteCopy);
      if (!notChanged && !this.quoteSaveRequested) {
        Swal.fire({
          title: "Important",
          html:
            "The Quote has been modified,<br> do you want to <strong>save changes</strong>?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.storeQuote(to.path);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
  beforeDestroy() {
    if (this.pdfDataUrl) {
      URL.revokeObjectURL(this.pdfDataUrl);
    }
  }
};
</script>
